import type { ReactElement } from 'react';

import { ForgotUserScreen } from 'common/accountActivationAndRecovery/ForgotUserScreen';

import { useDeviceHandoffAccountFlow } from '../hooks/useDeviceHandoffAccountFlow';

export const ForgotUserRoute = (): ReactElement => <ForgotUserScreen {...useDeviceHandoffAccountFlow().forgotUser} />;
